import { FeedItem, PageResponse } from 'components/context/types';
import { ArticleListType, BusinessFeedItem } from 'components/common/FeedTypes';

export enum NewsFilter {
    SOCIAL_MEDIA,
    TALENT_NEWS,
    APPOINTMENTS,
    COMPANY_EVENTS,
    JOBS,
    ALL,
    UNDEFINED
}

export const getNewsFilterEnumValue = (n: any): NewsFilter => {
    switch (Number(n)) {
        case 0:
            return NewsFilter.SOCIAL_MEDIA;
        case 1:
            return NewsFilter.TALENT_NEWS;
        case 2:
            return NewsFilter.APPOINTMENTS;
        case 3:
            return NewsFilter.COMPANY_EVENTS;
        case 4:
            return NewsFilter.JOBS;
        case 5:
            return NewsFilter.ALL;
        default:
            return NewsFilter.UNDEFINED;
    }
};

export const emptyPublicationPage: PageResponse<BusinessFeedItem> = {
    total: 0,
    content: [
        {
            articleListType: ArticleListType.UNDEFINED
        }
    ]
};

export const mapFeedItemsToBusinessFeedItem = (
    articleListType: ArticleListType,
    pageResponse: PageResponse<FeedItem>
): PageResponse<BusinessFeedItem> => {
    if (pageResponse.content) {
        const businessFeedItems: BusinessFeedItem[] = pageResponse.content.map(
            item => ({ ...item, articleListType })
        );
        return {
            content: businessFeedItems,
            total: pageResponse.total,
            page: pageResponse.page
        };
    }
    return { content: [], total: 0 };
};
